// import Setting360 from './Setting360';

export default {
  // component: Setting360,
  component: load(() => import(/* webpackChunkName: "Evaluation360-Setting360" */ './Setting360')),
  permissions: ["360EvaluationMenu/SettingMenu/360PatternMenu"],
  name: app.translate('routes.home.evaluation-360.Setting360'),
  icon: 'account-settings-variant',
  drawer: true,
};
